import {
  RuleGroupProps,
  useRuleGroup,
  RuleGroupBodyComponents,
} from "react-querybuilder";
import PowersearchRuleGroupHeaderElements from "./PowersearchRuleGroupHeaderElements";
import classNames from "classnames";
import PowersearchRuleGroupBodyComponents from "./PowersearchRuleGroupBodyComponents";
import PowersearchRuleGroupFooterElements from "./PowersearchRuleGroupFooterElements";
import CiroButton from "../../../../shared/CiroButton";
import { CiroButtonStyleEnum } from "../../../../shared/CiroButton";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "react";
import PowerUserFiltersContext from "../../../../../contexts/PowerUserFiltersContext";
import CiroErrorMsg from "../../../../shared/forms/CiroErrorMsg";

const PowersearchRuleGroup = (props: RuleGroupProps) => {
  const rg = useRuleGroup(props);
  const [isXMarkHovered, setIsXMarkHovered] = useState(false);
  const { showErrorMessages } = useContext(PowerUserFiltersContext);
  const pathLength = rg.path.length;

  const errorMessage = showErrorMessages
    ? (
        rg.schema.validationMap[rg.id || ""] as {
          reasons: string[];
        }
      )?.reasons?.[0]
    : undefined;

  return (
    <div className={classNames({ "py-4": pathLength > 0 })}>
      <div
        className={classNames("px-4", "border", "rounded-lg", {
          "border-red-200": isXMarkHovered,
          "border-gray-200": !isXMarkHovered,
        })}
      >
        <div
          className={classNames(
            "pt-4",
            "flex",
            "justify-between",
            "items-center",
            "pb-2",
          )}
        >
          <PowersearchRuleGroupHeaderElements
            {...(rg as Parameters<
              typeof PowersearchRuleGroupHeaderElements
            >[0])}
          />
          {rg.path.length > 0 && (
            <CiroButton
              analyticsField="Remove group from powerfilters"
              style={CiroButtonStyleEnum.UNSTYLED}
              customClassName={classNames(
                "hover:text-red-500",
                "text-gray-500",
              )}
              onClick={() => {
                rg.removeGroup();
              }}
              onMouseEnter={() => setIsXMarkHovered(true)}
              onMouseLeave={() => setIsXMarkHovered(false)}
            >
              <XMarkIcon className="h-4 w-4" />
            </CiroButton>
          )}
        </div>
        <div>
          <PowersearchRuleGroupBodyComponents
            {...(rg as Parameters<typeof RuleGroupBodyComponents>[0])}
          />
        </div>
        {errorMessage && <CiroErrorMsg error={errorMessage} />}
        {!rg.disabled && (
          <div className={classNames("pb-4", "pt-2")}>
            <PowersearchRuleGroupFooterElements
              {...(rg as Parameters<
                typeof PowersearchRuleGroupFooterElements
              >[0])}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PowersearchRuleGroup;
